function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import { getPlatformAddSolutionLink, getProductSignupWithSolutionLink, NEW_SOFT_SIGNUP_LINK, SIGNUP_WITH_GOOGLE_LINK, VERIFY_EMAIL_LINK } from "/constants/links";
import { CAMPAIGN_PRODUCT_COOKIE, EXCLUDE_FROM_SIGNUP_TESTS, IS_IN_KEEP_REGION_TEST, SOFT_SIGNUP_MOBILE_TEST_COOKIE_NAME, WEBSITE_PRODUCT_SIGNUP_COOKIE_NAME, WM_HIGH_INTENT_EXPERIENCE_COOKIE_NAME } from "constants/cookies";
import { getProductByClustersIds, updateUserClustersListWithSingleCluster } from "services/clusters-service";
import { getMondayUrl, getWelcomeBackCTAProps, isExistingUserInHeader, isExistingUserInWelcomeBackTest } from "services/monday-platform/existing-accounts-service";
import { HP_SIGNUP_BUTTON, SET_CLUSTER_FROM_SIGNUP_BUTTON_REASON } from "constants/clusters/sources";
import Colors from "styles/colors";
import { BLUE_COLOR_NAME, BRAND_BLACK_BACKGROUND_COLOR, BRAND_BLACK_TEXT_COLOR, BRAND_GREEN_DARK_TINT_01_COLOR_NAME, BRAND_PRIMARY_GREEN_COLOR_NAME, BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME, BRAND_WORK_MANAGEMENT_DARKER_TINT_COLOR_NAME, CRM_DARK_TINT_01_COLOR_NAME, CRM_DARKER_TINT_02_COLOR_NAME, CRM_GREEN_COLOR_NAME, CRM_PRIMARY_COLOR_NAME, DARK_CRM_GREEN_COLOR_NAME, DARK_DEV_GREEN_COLOR_NAME, DARK_MARKETING_RED_COLOR_NAME, DARK_PROJECTS_ORANGE_COLOR_NAME, DEV_DARKER_TINT_02_COLOR_NAME, DEV_PRIMARY_COLOR_NAME, DODGER_BLUE_COLOR_NAME, GRADIANT_WORKOS_IRIS_COLOR_NAME, SPACE_BLUE_COLOR_NAME, WHITE_COLOR_NAME, WORK_OS_IRIS_COLOR_NAME, WORKFORMS_RED_COLOR_NAME, BRAND_SERVICE_PRIMARY_COLOR_NAME, CRM_CTA_COLOR_NAME, DEV_CTA_COLOR_NAME, SERVICE_CTA_COLOR_NAME } from "styles/color-consts";
import { CRM_PRODUCT_ID, DEV_PRODUCT_ID, getPlatformProductID, getProductSignupURL, PLATFORM_PRODUCT_IDS, shouldGetProductSignup, WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
import Button from "/components/core/button/button-component";
import EmailInput from "/components/core/inputs/email-input-component";
import { CLICKED_SIGNUP_WITHOUT_INSERTING_EMAIL, EXISTING_ACCOUNT_MAIN_CTA_CLICKED, SIGNUP_FORM_SUBMIT, SIGNUP_MAIN_CTA_CLICKED, SIGNUP_START_FILL_EMAIL, SIGNUP_SUBMIT_CLICK_WITH_EMAIL_ERROR, SIGNUP_WITH_GOOGLE_CLICKED } from "/constants/bigbrain-event-types";
import { withGenericConfig } from "/contexts/generic-config-context";
import { withSegmentsData } from "contexts/segment-context";
import { withAbTests } from "contexts/ab-tests-context";
import { addParamToURL } from "utils/url";
import { shouldGetKeepRegionTest, shouldGetSignupByProductCampaign, shouldGetUnlimitedTimeCTATextTest } from "services/ab-tests/acquisition-ab-test-service";
import { trackEvent } from "/services/bigbrain-service";
import { PREVENT_FREE_TIER_PARAM } from "constants/query-params";
import { getScrollPercent } from "/services/dom-utils-service";
import { getCookie, removeCookie, setCookie, setCookieIfNeeded } from "services/cookies-service";
import { BELOW } from "/constants/button_additional_text_position";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
import { CLUSTER_TYPE } from "/constants/clusters/types";
import { CRM, GENERIC_CLUSTER } from "constants/clusters";
import DataLayerEventTypes from "constants/data-layer-event-types";
import { fireGtmEvent } from "client/services/gtm-service/gtm-service";
import GoogleIconSvg from "static/svg/google-icon.svg";
import { appendUrlSchemeIfNeeded, isAndroid, isMeta } from "utils/mobile";
import { updateReferrerBeforeSignup } from "client/services/signup/signup-service";
import { Global, css } from "@emotion/react";
import { StyledSignupCoreComponent } from "./signup-form-core-component.scss";
import { addParamsToUrl, NEW_SIGNUP_SOURCE_PARAM } from "./signup-form-core-service";
import WorkManagementIcon from "./product-icons/work-management-icon";
import CRMIcon from "./product-icons/crm-icon";
import DevIcon from "./product-icons/dev-icon";
import { isInTest, sendAbTestEvent } from "/services/new-ab-tests/new-ab-tests-service";
import { SIGNUP_BY_PRODUCT_CAMPAIGN } from "/constants/new-ab-tests";
const DEFAULT_CTA_KEY = "signup.cta";
const ENGLISH_CTA_TRANSLATION = "Get Started"; // english translation for event
const SIGNUP = "sign-up";
const PRODUCT_ID_TO_ICON = {
    [WORK_MANAGEMENT_PRODUCT_ID]: /*#__PURE__*/ _jsx(WorkManagementIcon, {}),
    [CRM_PRODUCT_ID]: /*#__PURE__*/ _jsx(CRMIcon, {}),
    [DEV_PRODUCT_ID]: /*#__PURE__*/ _jsx(DevIcon, {})
};
const CTA_LOCATION = {
    PRICING: "pricing",
    HEADER: "header",
    FIRST_FOLD: "first_fold",
    OTHER: "other"
};
const BRAND_ALLOWED_COLORS = [
    WHITE_COLOR_NAME,
    BLUE_COLOR_NAME,
    WORK_OS_IRIS_COLOR_NAME,
    GRADIANT_WORKOS_IRIS_COLOR_NAME,
    BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME,
    CRM_DARKER_TINT_02_COLOR_NAME,
    BRAND_PRIMARY_GREEN_COLOR_NAME,
    CRM_GREEN_COLOR_NAME,
    DEV_DARKER_TINT_02_COLOR_NAME,
    BRAND_BLACK_TEXT_COLOR,
    BRAND_BLACK_BACKGROUND_COLOR,
    WORKFORMS_RED_COLOR_NAME,
    DARK_MARKETING_RED_COLOR_NAME,
    DARK_CRM_GREEN_COLOR_NAME,
    DARK_PROJECTS_ORANGE_COLOR_NAME,
    DARK_DEV_GREEN_COLOR_NAME,
    CRM_DARK_TINT_01_COLOR_NAME,
    BRAND_GREEN_DARK_TINT_01_COLOR_NAME,
    BRAND_WORK_MANAGEMENT_DARKER_TINT_COLOR_NAME,
    DEV_PRIMARY_COLOR_NAME,
    CRM_PRIMARY_COLOR_NAME,
    BRAND_SERVICE_PRIMARY_COLOR_NAME,
    CRM_CTA_COLOR_NAME,
    DEV_CTA_COLOR_NAME,
    SERVICE_CTA_COLOR_NAME
];
const loadedAt = new Date().getTime();
class SignupCoreComponent extends PureComponent {
    shouldSeeOnlyButton(props) {
        const { forceInputHide, forceDefaultForm, isMobileOrTabletBrowser } = props;
        if (forceInputHide) return true;
        if (forceDefaultForm) return false;
        if (isMobileOrTabletBrowser) {
            return false;
        }
        return true;
    }
    getProductSignupURLWithProductId() {
        return getProductSignupURL(this.getSignupProductId());
    }
    handleProductCookie() {
        const { excludeFromWMHighIntentExperienceTest } = this.props;
        const productForSignup = this.getSignupProductId();
        if (this.useProductSignup() && productForSignup === WORK_MANAGEMENT_PRODUCT_ID && !excludeFromWMHighIntentExperienceTest) {
            setCookie(WM_HIGH_INTENT_EXPERIENCE_COOKIE_NAME, true, {
                expires: 1
            }); // Mark product cookie to sync with platform - live for 1 day
        } else {
            // In case user clicked on wm high intent Get Started, clicked back and then clicked on another 'Get Started'
            // button that is not WM high intent
            removeCookie(WM_HIGH_INTENT_EXPERIENCE_COOKIE_NAME);
        }
        if (!this.onlyButton) {
            if (this.useProductSignup() && productForSignup !== WORK_MANAGEMENT_PRODUCT_ID) {
                const platformProduct = PLATFORM_PRODUCT_IDS[productForSignup];
                if (platformProduct) {
                    setCookie(WEBSITE_PRODUCT_SIGNUP_COOKIE_NAME, platformProduct, {
                        expires: 1
                    });
                }
            } else {
                removeCookie(WEBSITE_PRODUCT_SIGNUP_COOKIE_NAME);
            }
        }
    }
    hasOverridePlatformUrlForExistingAccount() {
        const { persistantCookies, existingAccount: { platformUrlOverrideForExistingAccount } } = this.props;
        return platformUrlOverrideForExistingAccount && isExistingUserInHeader(persistantCookies);
    }
    getPlatformOverrideUrlForExistingAccount() {
        const { existingAccount: { platformUrlOverrideForExistingAccount } } = this.props;
        return getMondayUrl(platformUrlOverrideForExistingAccount);
    }
    getSubmitUrl(campaignProductCookie) {
        const { submitUrl, signupWithsolutionAppReferenceId } = this.props;
        let overrideUrl;
        if (!this.onlyButton) {
            // mobile / popup - with email
            overrideUrl = addParamToURL(addParamsToUrl(VERIFY_EMAIL_LINK), NEW_SIGNUP_SOURCE_PARAM, "1");
            setCookie(SOFT_SIGNUP_MOBILE_TEST_COOKIE_NAME, true);
        } else if (this.hasOverridePlatformUrlForExistingAccount()) {
            overrideUrl = this.getPlatformOverrideUrlForExistingAccount();
        } else if (this.useProductSignup() && signupWithsolutionAppReferenceId) {
            // sign up with both product and solution - use product signup URL with solution_id parameter
            overrideUrl = getProductSignupWithSolutionLink(this.getSignupProductId(), signupWithsolutionAppReferenceId);
        } else if (this.useProductSignup()) {
            overrideUrl = this.getProductSignupURLWithProductId();
        } else if (signupWithsolutionAppReferenceId) {
            // sign up with specific solution
            overrideUrl = getPlatformAddSolutionLink(signupWithsolutionAppReferenceId);
        } else if (campaignProductCookie) {
            overrideUrl = getProductSignupURL(campaignProductCookie);
        }
        return overrideUrl || submitUrl;
    }
    componentDidMount() {
        const { focusOnLoad, isFirstSegment, isPreview, isMobileOrTabletBrowser } = this.props;
        if (isPreview) return;
        const shouldFocus = (focusOnLoad || isFirstSegment) && !isMobileOrTabletBrowser;
        shouldFocus && this.focusOnInput();
        window.addEventListener("pageshow", this.subscribeToBackNavigation);
    }
    componentWillUnmount() {
        window.removeEventListener("pageshow", this.subscribeToBackNavigation);
    }
    submitFormIfNeeded(event) {
        if (event.key === "Enter") {
            this.handleSubmit();
            event.preventDefault();
        }
    }
    updateEmail(event) {
        const { emailValue } = this.state;
        const { errorStateCallback, parentSegment, segmentNumber } = this.props;
        if (!emailValue) trackEvent(SIGNUP_START_FILL_EMAIL, {
            info1: parentSegment,
            info2: this.getButtonText(),
            info3: segmentNumber
        });
        this.setState({
            emailValue: event.target.value
        });
        errorStateCallback(false);
    }
    handleSubmit(kind = SIGNUP) {
        var _this = this;
        return _async_to_generator(function*() {
            const { errorStateCallback, placement, parentSegment, buttonSource, segmentNumber } = _this.props;
            const loadingButtonKey = "isLoading";
            _this.setState({
                [loadingButtonKey]: true
            });
            if (!_this.onlyButton && !_this._emailInput.isValid()) {
                const { emailValue } = _this.state;
                _this.setState({
                    isLoading: false
                });
                _this._emailInput.focus();
                errorStateCallback(true);
                trackEvent(SIGNUP_SUBMIT_CLICK_WITH_EMAIL_ERROR, {
                    info1: emailValue,
                    info2: parentSegment,
                    info3: segmentNumber
                }); // Not PII since email isn't valid.
                return;
            }
            trackEvent(SIGNUP_FORM_SUBMIT, {
                placement,
                kind,
                info1: parentSegment,
                info3: buttonSource
            });
            _this.handleBeforeSubmitCallback();
            yield _this.handleUserSignup(kind);
        })();
    }
    handleUserSignup(kind) {
        var _this = this;
        return _async_to_generator(function*() {
            const { skipUpdateCluster } = _this.props;
            if (!skipUpdateCluster) {
                _this.updateUserCluster();
            }
            const scrollPercent = yield getScrollPercent();
            _this.handleProductCookie();
            _this.sendGetStartedEvent(kind, scrollPercent);
            updateReferrerBeforeSignup();
            _this._form.submit();
        })();
    }
    getButtonText() {
        const { useCtaText, ctaText, translate } = this.props;
        const { persistantCookies, existingAccount: { existingAccountCtaText } } = this.props;
        let buttonText;
        // If existing account
        if (existingAccountCtaText && isExistingUserInHeader(persistantCookies)) {
            buttonText = existingAccountCtaText;
        } else if (useCtaText && ctaText) {
            buttonText = ctaText;
        }
        if (!buttonText) {
            buttonText = translate(DEFAULT_CTA_KEY);
        }
        return buttonText;
    }
    getPlaceholderText() {
        const { placeholder, translate } = this.props;
        return placeholder || translate("signup.emailInputPlaceholder");
    }
    onClick(kind) {
        const { emailValue, isLoading } = this.state;
        if (isLoading) return; //	disable in button cause css issues, need to think about it
        if (!this.onlyButton && !emailValue) {
            trackEvent(CLICKED_SIGNUP_WITHOUT_INSERTING_EMAIL);
        }
        this.handleSubmit(kind);
    }
    render() {
        const { buttonSize, origin, isErrorState, className, forceHorizontal, emailInputOpened, borderColor, disableButtonAnimation, placeholderFocusColor, withButtonArrow, freeTierForcePrevent, additionalText, isMobileInputTransparent, isMobileOrTabletBrowser, showGoogleConnectOnMobile, invert, displayedOnDarkTheme, forceVerticalGoogleConnect, translate, pricingDetails, pageSubClusterId, paintButtonColor, existingAccount, productIdToUse, useCtaIcon, buttonAlign, useExperimentalAnimation, forceInputHide, buttonClassName } = this.props;
        const { isLoading } = this.state;
        const campaignProductCookie = getCookie(CAMPAIGN_PRODUCT_COOKIE);
        let hideSignupButton = false;
        let buttonTextToUse = this.getButtonText();
        const placeholderToUse = this.getPlaceholderText();
        const submitUrl = this.getSubmitUrl(campaignProductCookie);
        let fullUrl = addParamToURL(submitUrl, "origin", origin);
        fullUrl = freeTierForcePrevent ? addParamToURL(fullUrl, PREVENT_FREE_TIER_PARAM, freeTierForcePrevent) : fullUrl;
        const buttonUpdatedColor = this.getButtonColor();
        let clickAction = this.signupClicked;
        // existing account flow:
        if (this.shouldReplaceGetStartedWithGoToAccount()) {
            const ctaProps = getWelcomeBackCTAProps({
                productId: this.getSignupProductId(),
                clusterId: this.getSignupClusterId(),
                subClusterId: pageSubClusterId,
                pricingDetails,
                existingAccount
            });
            // this flow disconnects the form and it's submission completely
            buttonTextToUse = translate(ctaProps.ctaTextKey);
            clickAction = ()=>this.gotToAccount(ctaProps.platformRedirectUrl, ctaProps.ctaTextKey);
            hideSignupButton = ctaProps.hideButton;
        }
        // Google connect
        const renderGoogleConnect = isMobileOrTabletBrowser && showGoogleConnectOnMobile || forceVerticalGoogleConnect;
        return /*#__PURE__*/ _jsxs(StyledSignupCoreComponent, {
            className: classnames("signup-form-core-component-wrapper", className, {
                error: isErrorState,
                "force-horizontal": forceHorizontal,
                "opened-input": emailInputOpened,
                "vertical-google-connect": renderGoogleConnect,
                "dark-theme": displayedOnDarkTheme,
                "mobile-or-tablet": isMobileOrTabletBrowser
            }),
            children: [
                /*#__PURE__*/ _jsxs("form", {
                    className: "signup-form",
                    action: fullUrl,
                    "data-origin": origin,
                    method: "POST",
                    noValidate: true,
                    ref: (el)=>this._form = el,
                    children: [
                        !this.onlyButton && /*#__PURE__*/ _jsx(EmailInput, {
                            className: classnames("signup-input", {
                                "force-horizontal": forceHorizontal,
                                transparent: isMobileInputTransparent,
                                "mobile-or-tablet": isMobileOrTabletBrowser
                            }),
                            ref: (el)=>this._emailInput = el,
                            value: this.state.emailValue,
                            onChange: this.updateEmail,
                            placeholder: placeholderToUse,
                            onKeyPress: this.submitFormIfNeeded,
                            autoComplete: "on",
                            placeholderFocusColor: placeholderFocusColor,
                            style: {
                                borderColor
                            },
                            isMobileOrTabletBrowser: isMobileOrTabletBrowser
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: classnames("signup-button-wrapper", additionalText && `additional-text additional-text-${this.additionalTextPosition}`, {
                                "button-with-arrow": withButtonArrow,
                                "hide-button": hideSignupButton,
                                "with-icon": useCtaIcon,
                                "with-experimental-animation": useExperimentalAnimation
                            }),
                            children: [
                                /*#__PURE__*/ _jsxs(Button, {
                                    className: `signup-button${buttonClassName ? ` ${buttonClassName}` : ""}`,
                                    color: buttonUpdatedColor,
                                    size: buttonSize,
                                    isLoading: isLoading,
                                    onClickCallback: clickAction,
                                    disableAnimation: disableButtonAnimation,
                                    dataSpinnerColor: this.getButtonSpinnerColor(),
                                    invert: invert,
                                    hasArrow: withButtonArrow,
                                    paintButtonColor: paintButtonColor,
                                    buttonAlign: buttonAlign,
                                    children: [
                                        useCtaIcon && /*#__PURE__*/ _jsx("div", {
                                            className: "product-icon",
                                            children: PRODUCT_ID_TO_ICON[productIdToUse]
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "signup-text",
                                            children: buttonTextToUse
                                        })
                                    ]
                                }),
                                this.renderTextNextToButtonIfNeeded()
                            ]
                        }),
                        !this.onlyButton && this.renderTermsOfService()
                    ]
                }),
                renderGoogleConnect && this.renderGoogleConnect(),
                /*#__PURE__*/ _jsx(Global, {
                    styles: css`
            .error-handling-component .shake .tooltip {
              bottom: 142px;
              width: 100%;
              transform: translate(0, -120%);
            }
          `
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "getSignupProductId", ()=>{
            const { signupProductId, pageProductId, signupClusterId, pageClusterId, abTests } = this.props;
            const acceptedClustersForProductSignup = [
                CRM
            ];
            const productId = signupProductId || pageProductId;
            if (productId) {
                return productId;
            }
            const clusterId = signupClusterId || pageClusterId;
            if (clusterId && acceptedClustersForProductSignup.includes(clusterId)) {
                return getProductByClustersIds([
                    clusterId
                ]);
            }
        });
        _define_property(this, "getSignupClusterId", ()=>{
            const { signupClusterId, pageClusterId } = this.props;
            return signupClusterId || pageClusterId;
        });
        _define_property(this, "setKeepRegionTestCookieIfNeeded", ()=>{
            const { abTests, cloudfrontViewerCountry, isMobileOrTabletBrowser, signupWithsolutionAppReferenceId } = this.props;
            if (!this.getSignupProductId() && !isMobileOrTabletBrowser && !signupWithsolutionAppReferenceId) {
                // we exclude mobile viewers from the test at the moment
                // we also exclude the products from it at the moment since we're not sure they're available in AU
                if (shouldGetKeepRegionTest(abTests, cloudfrontViewerCountry, true)) {
                    // we want to run the test only for regular desktop signups
                    setCookieIfNeeded(IS_IN_KEEP_REGION_TEST, true);
                }
            }
        });
        _define_property(this, "useProductSignup", ()=>{
            const { forceProductSignup } = this.props;
            const productIdToUse = this.getSignupProductId();
            return productIdToUse && (forceProductSignup || shouldGetProductSignup(productIdToUse));
        });
        _define_property(this, "subscribeToBackNavigation", (event)=>{
            if (event === null || event === void 0 ? void 0 : event.persisted) {
                this.setState({
                    isLoading: false,
                    isGoogleConnectLoading: false
                });
            }
        });
        _define_property(this, "focusOnInput", ()=>{
            this._emailInput && this._emailInput.focus();
        });
        _define_property(this, "handleBeforeSubmitCallback", ()=>{
            const { beforeSubmitCallback, shouldSendClustersAsParams } = this.props;
            if (beforeSubmitCallback) {
                const response = beforeSubmitCallback();
                // Add clusters to form action url
                // We run this here because clusterIds are manipulated after click
                // When the submitUrl is already assigned to the form
                if (response && response.params && shouldSendClustersAsParams) {
                    const keys = Object.keys(response.params);
                    keys.forEach((key)=>{
                        this._form.action = addParamToURL(this._form.action, key, response.params[key]);
                    });
                }
            }
        });
        _define_property(this, "updateUserCluster", ()=>{
            const { pageSubClusterId } = this.props;
            const clusterToReport = this.getSignupClusterId() || GENERIC_CLUSTER;
            updateUserClustersListWithSingleCluster(clusterToReport, CLUSTER_TYPE, HP_SIGNUP_BUTTON, {
                setSignupCluster: true,
                reason: SET_CLUSTER_FROM_SIGNUP_BUTTON_REASON,
                sendBigBrainEvent: true,
                useCaseId: pageSubClusterId
            });
        });
        _define_property(this, "getCTALocationForGTM", ()=>{
            const { segmentNumber, isPricingPage } = this.props;
            if (isPricingPage) {
                return CTA_LOCATION.PRICING;
            }
            if (segmentNumber === 0) {
                return CTA_LOCATION.HEADER;
            }
            if (segmentNumber === 1) {
                return CTA_LOCATION.FIRST_FOLD;
            }
            return CTA_LOCATION.OTHER;
        });
        _define_property(this, "sendGetStartedEvent", (kind, scrollPercent)=>{
            const { placement, buttonId, signupClusterId, segmentNumber, segmentType, extraData, useCtaText, ctaText } = this.props;
            let englishText;
            if (!useCtaText) {
                englishText = ENGLISH_CTA_TRANSLATION;
            }
            const signupProductId = this.getSignupProductId();
            const productKind = signupProductId ? getPlatformProductID(signupProductId) : undefined;
            const ctaClickData = {
                placement,
                kind,
                info1: segmentType,
                info2: this.getButtonText(),
                info3: signupClusterId,
                direct_object_id: scrollPercent,
                direct_object: window.visitGuid,
                board_kind: buttonId,
                value: segmentNumber,
                data: _object_spread({
                    timeStillPageLoad: new Date().getTime() - loadedAt,
                    englishText,
                    signupProductId,
                    productKind,
                    click_time: Date.now()
                }, extraData)
            };
            trackEvent(SIGNUP_MAIN_CTA_CLICKED, ctaClickData);
            fireGtmEvent(DataLayerEventTypes.SIGNUP_CLICKED, {
                click_text: this.getButtonText(),
                click_location: this.getCTALocationForGTM()
            });
        });
        _define_property(this, "shouldReplaceGetStartedWithGoToAccount", ()=>{
            const { abTests, useCtaText, signupWithsolutionAppReferenceId, forceGoToMyAccount, persistantCookies, pricingDetails } = this.props;
            if (forceGoToMyAccount) return true;
            if (useCtaText && !pricingDetails || signupWithsolutionAppReferenceId) return false;
            return this.onlyButton && isExistingUserInWelcomeBackTest(abTests, persistantCookies);
        });
        _define_property(this, "renderTextNextToButtonIfNeeded", ()=>{
            const { additionalText, additionalTextMaxWidth, abTests, translate } = this.props;
            if (!additionalText) return;
            let textToUse = additionalText;
            let maxWidthToUse = additionalTextMaxWidth;
            if (textToUse.indexOf("Free forever. No credit card.") > -1 && shouldGetUnlimitedTimeCTATextTest(abTests, true)) {
                textToUse = translate("signup.button.unlimitedTimeCta");
                maxWidthToUse = null;
            }
            return /*#__PURE__*/ _jsx("div", {
                className: classnames("additional-button-text", this.additionalTextPosition),
                style: {
                    maxWidth: maxWidthToUse
                },
                children: /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                    text: textToUse
                })
            });
        });
        _define_property(this, "clickGoogleConnectAction", ()=>{
            const { skipUpdateCluster } = this.props;
            this.setState({
                isGoogleConnectLoading: true
            });
            trackEvent(SIGNUP_WITH_GOOGLE_CLICKED);
            fireGtmEvent(DataLayerEventTypes.SIGNUP_WITH_GOOGLE_CLICKED);
            this.handleBeforeSubmitCallback();
            if (!skipUpdateCluster) {
                this.updateUserCluster();
            }
            this.setKeepRegionTestCookieIfNeeded();
            this.setExcludeFromSignupTestsCookieIfNeeded();
            this.handleProductCookie();
            window.location.href = appendUrlSchemeIfNeeded(SIGNUP_WITH_GOOGLE_LINK);
        });
        _define_property(this, "shouldRenderMobileOrTabletGoogleConnect", ()=>{
            const { isMobileOrTabletBrowser, showGoogleConnectOnMobile, forceVerticalGoogleConnect } = this.props;
            return isMobileOrTabletBrowser && showGoogleConnectOnMobile && (!isMeta() || isMeta() && isAndroid()) || forceVerticalGoogleConnect;
        });
        _define_property(this, "renderGoogleConnect", ()=>{
            if (this.shouldRenderMobileOrTabletGoogleConnect()) return this.renderMobileGoogleConnect();
            return null;
        });
        _define_property(this, "googleConnectButton", ()=>{
            const { translate, buttonSize, googleOverrideCtaKey } = this.props;
            const { isGoogleConnectLoading } = this.state;
            const googleConnectColorData = this.getGoogleConnectColorData();
            const googleConnectKey = googleOverrideCtaKey || "signup.continueWith";
            return /*#__PURE__*/ _jsx(Button, {
                className: "google-connect-button",
                color: googleConnectColorData.buttonColor,
                size: buttonSize,
                onClickCallback: this.clickGoogleConnectAction,
                isLoading: isGoogleConnectLoading,
                dataSpinnerColor: Colors[googleConnectColorData.spinnerColorName],
                withBorder: "true",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "google-button-inner",
                    children: [
                        /*#__PURE__*/ _jsxs("span", {
                            className: "continue-text",
                            children: [
                                " ",
                                translate(googleConnectKey),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ _jsx(GoogleIconSvg, {
                            className: "google-icon"
                        })
                    ]
                })
            });
        });
        _define_property(this, "renderMobileGoogleConnect", ()=>{
            const { translate, googleSeparatorColor } = this.props;
            const colorStyle = {
                color: Colors[googleSeparatorColor],
                borderColor: Colors[googleSeparatorColor]
            };
            return /*#__PURE__*/ _jsxs("div", {
                className: classnames("social-connect-section"),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "google-separator",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "seperator-line",
                                style: colorStyle
                            }),
                            /*#__PURE__*/ _jsxs("span", {
                                className: "separator-text",
                                style: colorStyle,
                                children: [
                                    translate("signup.or"),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "seperator-line",
                                style: colorStyle
                            })
                        ]
                    }),
                    this.googleConnectButton()
                ]
            });
        });
        _define_property(this, "getGoogleConnectColorData", ()=>{
            const buttonColor = this.getButtonColor();
            const options = {
                [WORK_OS_IRIS_COLOR_NAME]: {
                    spinnerColorName: WORK_OS_IRIS_COLOR_NAME,
                    buttonColor: "white-iris"
                },
                [DODGER_BLUE_COLOR_NAME]: {
                    spinnerColorName: DODGER_BLUE_COLOR_NAME,
                    buttonColor: "white-dodger"
                },
                [SPACE_BLUE_COLOR_NAME]: {
                    spinnerColorName: SPACE_BLUE_COLOR_NAME,
                    buttonColor: "white"
                }
            };
            return options[buttonColor] || {
                spinnerColorName: SPACE_BLUE_COLOR_NAME,
                buttonColor: "white"
            };
        });
        _define_property(this, "getButtonColor", ()=>{
            const { buttonColor } = this.props;
            if (!BRAND_ALLOWED_COLORS.includes(buttonColor)) {
                return WORK_OS_IRIS_COLOR_NAME;
            }
            return buttonColor;
        });
        _define_property(this, "signupClicked", ()=>{
            this.setKeepRegionTestCookieIfNeeded();
            this.setExcludeFromSignupTestsCookieIfNeeded();
            this.onClickSignup();
        });
        _define_property(this, "gotToAccount", (platformRedirectUrl, ctaTextKey)=>{
            const { buttonId, signupClusterId, segmentNumber, segmentType, translate } = this.props;
            const buttonTextToUse = translate(ctaTextKey);
            const englishText = "Go to my account"; // CTA's english translation for event
            const ctaClickData = {
                placement: this.getSignupProductId(),
                kind: platformRedirectUrl,
                info1: segmentType,
                info2: buttonTextToUse,
                info3: signupClusterId,
                board_kind: buttonId,
                value: segmentNumber,
                data: {
                    englishText
                }
            };
            trackEvent(EXISTING_ACCOUNT_MAIN_CTA_CLICKED, ctaClickData);
            window.location = platformRedirectUrl;
        });
        _define_property(this, "renderTermsOfService", ()=>{
            const { translate } = this.props;
            return /*#__PURE__*/ _jsx("div", {
                className: "terms-of-service",
                children: /*#__PURE__*/ _jsx("span", {
                    dangerouslySetInnerHTML: {
                        __html: translate("mobileSignup.termsOfService")
                    }
                })
            });
        });
        _define_property(this, "getButtonSpinnerColor", ()=>{
            const { buttonSpinnerColor } = this.props;
            if (buttonSpinnerColor) return buttonSpinnerColor;
            return this.getButtonColor() === WHITE_COLOR_NAME ? Colors[BRAND_BLACK_BACKGROUND_COLOR] : null;
        });
        _define_property(this, "setExcludeFromSignupTestsCookieIfNeeded", ()=>{
            const { excludeFromSignupTests } = this.props;
            setCookieIfNeeded(EXCLUDE_FROM_SIGNUP_TESTS, excludeFromSignupTests);
        });
        this.state = {
            emailValue: "",
            isLoading: false,
            isGoogleConnectLoading: false
        };
        this._emailInput = null;
        this.updateEmail = this.updateEmail.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUserSignup = this.handleUserSignup.bind(this);
        this.submitFormIfNeeded = this.submitFormIfNeeded.bind(this);
        this.onClickSignup = this.onClick.bind(this, SIGNUP);
        this.onlyButton = this.shouldSeeOnlyButton(props);
        const { isMobileOrTabletBrowser, additionalTextPosition } = props;
        this.additionalTextPosition = isMobileOrTabletBrowser ? BELOW : additionalTextPosition;
    }
}
SignupCoreComponent.defaultProps = {
    focusOnLoad: false,
    disableButtonAnimation: false,
    borderColor: "grey",
    submitUrl: NEW_SOFT_SIGNUP_LINK,
    origin: "hp_fullbg_page_header",
    forceDefaultForm: false,
    forceInputHide: false,
    withButtonArrow: false,
    useCtaText: false,
    ctaText: null,
    additionalText: false,
    additionalTextPosition: BELOW,
    additionalTextMaxWidth: null,
    buttonId: null,
    segmentNumber: null,
    isMobileInputTransparent: false,
    skipUpdateCluster: false,
    showGoogleConnectOnMobile: false,
    invert: null,
    displayedOnDarkTheme: false,
    forceVerticalGoogleConnect: false,
    forceProductSignup: false,
    forceGoToMyAccount: false,
    existingAccount: {
        platformUrlOverrideForExistingAccount: ""
    },
    extraData: {}
};
export default withSegmentsData(withAbTests(withGenericConfig(SignupCoreComponent)));
